import React from 'react'
import InsuranceInfo from './InsuranceInfo'
import Layout from '../../components/layout/Layout'
import WhyTakeOutFamilyLifeInsurance from './WhyTakeOutFamilyLifeInsurance'
import { WhatIsFamilyLifeInsurance } from './WhatIsFamilyLifeInsurance'
import WhatIsBmgMed from './WhatIsBmgMed'
import BmgMedPlans from './BmgMedPlans'
import Faq from '../../components/faq/Faq'
import { useInsurance } from './hook/useInsurance'

function Insurance() {
    const { faqs, getSubHeader, onGoToRegister } = useInsurance()
    return (
        <Layout subHeader={getSubHeader()}>
            <InsuranceInfo onGoToRegister={onGoToRegister} />
            <WhatIsBmgMed onGoToRegister={onGoToRegister} />
            <BmgMedPlans onGoToRegister={onGoToRegister} />
            <WhatIsFamilyLifeInsurance onGoToRegister={onGoToRegister} />
            <WhyTakeOutFamilyLifeInsurance onGoToRegister={onGoToRegister} />
            <Faq
                faqs={faqs}
                title={'Tire suas dúvidas'}
            />
        </Layout>
    )
}

export default Insurance